import a from "../utils/computeOffsets.js";
function r(t) {
  var e = t.state, p = t.name;
  e.modifiersData[p] = a({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const f = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: r,
  data: {}
};
export {
  f as default
};
